import {Component, OnInit} from '@angular/core';
import {ShoppingCartService} from '../../Services/shopping-cart.service';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {DataRequestItem} from '../../Pages/datarequest/model/datarequest.model';


@Component({
  selector: 'app-cart-widget',
  templateUrl: './cart-widget.component.html',
  styleUrls: ['./cart-widget.component.scss']
})
export class CartWidgetComponent implements OnInit {

  storageDataRequestItems: DataRequestItem[] = [];
  cartCount = 0;

  constructor(
    private $localStorage: LocalStorageService,
    private $sessionStorage: SessionStorageService,
    private shoppingCartService: ShoppingCartService) {
  }

  ngOnInit(): void {


    this.retrieveFromCart();
    this.observeCartChanges();
  }

  retrieveFromCart() {
    const c = this.shoppingCartService.retrieveCart();
    if (c !== null) {
      this.storageDataRequestItems = c;
      this.cartCount = this.storageDataRequestItems.length;
    }
  }

  private observeCartChanges(rememberMe = true) {
    if (rememberMe) {
      this.$localStorage.observe('dataRequestItems')
        .subscribe((storageDataRequestItems: DataRequestItem[]) => {
          this.storageDataRequestItems = storageDataRequestItems;
          this.cartCount = this.storageDataRequestItems.length;
        });
    } else {
      // TODO
    }
  }
}
